<template>
  <v-card>
    <v-card-title>
      Registered Ratings
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :items="expertratings" :search="search" :pagination.sync="pagination" :rows-per-page-items="listSize">
      <template v-slot:items="props">
        <td>{{ props.item.expertId.firstName }} {{ props.item.expertId.lastName }}</td>
        <td>{{ Math.round(props.item.rating) }}</td>
        <td>{{ props.item.review }}</td>
        <td>{{ props.item.report_review }}</td>
        <td v-if="props.item.sonkoId != undefined">{{ props.item.sonkoId.countryCode }}{{ props.item.sonkoId.phone }}</td>
        <td v-else>{{ props.item.phone }}</td>
        <td v-if="props.item.sonkoId != undefined">{{ props.item.sonkoId.firstName }} {{ props.item.sonkoId.lastName }}</td>
        <td v-else>{{ props.item.username }}</td>
        <td class>{{ props.item.createdAt | moment("Do MMM YYYY") }}</td>
        <td>
          <v-btn icon @click="editModal(props.item)">
            <v-icon color="orange darken-2">edit</v-icon>
          </v-btn>
        </td>
        <td class>
          <v-btn icon @click="deleteModal(props.item)">
            <v-icon color="red">delete</v-icon>
          </v-btn>
        </td>
      </template>
      <v-alert
        v-slot:no-results
        :value="true"
        color="error"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
    </v-data-table>

    <!-- delete dialog -->
    <v-dialog v-model="delete_dialog" max-width="750px">
      <v-toolbar class="red" dark dense>
        <v-toolbar-title>Delete Review</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="delete_dialog=false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
              <h5>Are you sure you want to delete this review?</h5>
            </v-flex>
            <v-flex xs12 sm12 v-if="expertratingError != ''" class="mb-2">
              <span style="color: red;" >{{ expertratingError }}</span>
            </v-flex>
            <v-flex xs12>
              <v-btn color="red" class="right" small dark @click="deleteReview" :loading="loader">
                <v-icon left>delete</v-icon>Yes
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- end of delete  -->

    <!-- Review editing -->
    <v-dialog v-model="editDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title class="title">Edit Review</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click.native="editDialog = false">
          <v-icon color="white">clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-textarea
                  v-validate="'required'"
                  :error-messages="errors.collect('review')"
                  data-vv-name="review"
                  v-model="editItem.review"
                  label="Review Content"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-btn class="primary" @click="save" :loading="loader">
                  <v-icon left>save</v-icon>Save
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End -->

  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["user"])
  },
  props: {
    expertratings: {
      type: Array,
      default: [],
      required: true
    }
  },
  data() {
    return {
      search: "",
      delete_dialog: false,
      pagination: {
        rowsPerPage: 10
      },
      dataItem: {},
      loader: false,
      headers: [
        { text: "Expert", value: "expertId.firstName" },
        { text: "Rating", value: "rating" },
        { text: "Review", value: "review" },
        { text: "Expert Review Feedback", value: "report_review" },
        { text: "Phone", value: "phone" },
        { text: "Name", value: "username" },
        { text: "Date Created", value: "createdAt" },
        { text: "Action", value: "Edit" },
        { text: "Action", value: "action" }
      ],
      expertratingError: '',
      editDialog: false,
      editItem: {},
      listSize: [5,10,25,50,100,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
    };
  },
  methods: {
    editModal(item) {
      this.editItem = Object.assign({}, item);
      this.editDialog = true;
    },
    deleteModal(item) {
      this.dataItem = Object.assign({}, item);
      this.delete_dialog = true;
      this.expertratingError = '';
    },
    deleteReview(id) {
      const review = this.dataItem;
      const reviewUser = this.user._id;
      const self = this;
      self.loader = true;
      const res = this.$store
        .dispatch("remove", "/review/expert/" + reviewUser + '/' + review._id)
        .then(res => {
          if(res.state) {
            self.loader = false;
            location.reload();
          } else {
            self.expertratingError = res.msg;
            self.loader = false;
          }
        })
        .finally(() => {});
    },
    save() {
      const data = this.editItem;
      this.loader = true;
      const self = this;
      const res = this.$store
        .dispatch("put", { url: "/review/expert/"+this.editItem._id, data })
        .then(res => {
          self.loader = false;
          location.reload();
        });
    }
  }
};
</script>